import requests from '../request'


// 分页查询预案演练
export const plandrillPagelistAPI = (data) => {
  data = {
    ...data,
    strUserGuid:localStorage.getItem('userId'),
    userRoleList:JSON.parse( localStorage.getItem('userRoleLists'))
  }
  return requests({
    url: '/api/plan/plandrill/pagelist',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 新增预案演练
export const planPlandrillGetAPI = (params) => {
  return requests({
    url: '/api/plan/plandrill/get',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 新增预案演练
export const planPlandrillAddAPI = (data) => {
  return requests({
    url: '/api/plan/plandrill/add',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 编辑预案演练
export const planPlandrillUpdateAPI = (data) => {
  return requests({
    url: '/api/plan/plandrill/update',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
